import L from 'leaflet';

// import { BASE_URL } from '../../services/api';
const BASE_URL = '/';

/* ========== Marcadores ========== */
const iconeMarcadorPadrao = `${BASE_URL}images/mapa/default.png`;

/* Referência: https://leafletjs.com/reference-1.5.0.html#icon */
const gerarEstiloMarcador = icone => ({
    iconUrl: icone,
    // shadowUrl: `${BASE_URL}images/mapa/marcador_sombra.png`,
    // shadowAnchor: [20, 40],
    // shadowSize: [40, 40],
    iconSize: [21, 26],
    iconAnchor: [21, 26],
    popupAnchor: [1, -25],
    tooltipAnchor: [16, -25]
});

const Marcador = {
    padrao: L.icon(gerarEstiloMarcador(iconeMarcadorPadrao))
};

/* ========== Geometrias ========== */

/* Referência: https://leafletjs.com/reference-1.5.0.html#path */
const gerarEstiloGeometria = (
    strokeColor,
    fillColor,
    fillOpacity,
    dashArray,
    weight = 2
) => ({
    stroke: true,
    color: strokeColor,
    fillColor,
    fillOpacity,
    weight,
    dashArray
});

const Geometria = {
    default: gerarEstiloGeometria('#5DC1FF', '#5DC1FF', 0.4),
    geolocalizacao: gerarEstiloGeometria('#19dc19', '#19dc19', 0.1),
    imovelRuralCandidato: gerarEstiloGeometria(
        '#ff4943',
        '#ff4943',
        0.2,
        null,
        4
    ),
    imovelRuralCandidatoParaguai: gerarEstiloGeometria(
        '#ff4943',
        '#ff4943',
        0,
        null,
        1
    ),
    municipio: gerarEstiloGeometria('#cbcbcb', '#cbcbcb', 0, null, 2),
    area: gerarEstiloGeometria('#0AFF00', '#0AFF00', 0),
    areaProximidade: gerarEstiloGeometria('#0AFF00', '#0AFF00', 0),
    car: gerarEstiloGeometria('#F9BE04', '#F9BE04', 0.2, null, 1),
    imovelParaguai: gerarEstiloGeometria('#F9BE04', '#F9BE04', 0, null, 1),
    carHighlight: gerarEstiloGeometria('#F9BE04', '#F9BE04', 0.5, null, 2),
    operacaoTerritorio: gerarEstiloGeometria('yellow', 'yellow', 0),
    historicoAgricola: gerarEstiloGeometria('#6aa84f', '#6aa84f', 0.5, null, 2),
    operacaoGleba: gerarEstiloGeometria('#F56600', '#F56600', 0),
    operacaoGlebaAreaTotalTerritorio: gerarEstiloGeometria(
        '#F56600',
        '#F56600',
        0.4,
        null,
        1
    ),
    operacaoGlebaDesabilitada: gerarEstiloGeometria(
        '#C9CEBD',
        '#C9CEBD',
        0,
        null,
        1
    ),
    operacaoGlebaHighlight: gerarEstiloGeometria(
        '#F9BE04',
        '#F9BE04',
        0.5,
        null,
        2
    ),
    restricao: gerarEstiloGeometria('red', 'red', 0.3, null, 3),
    restricaoSelecionadaZoom: gerarEstiloGeometria('yellow', 'yellow', 0, 5)
};

export const getEstiloGeometria = idTipo => {
    return Geometria[idTipo];
};

/* ========== Outras configurações ========== */
const Config = {};

L.Icon.Default.prototype.options = {
    iconUrl: iconeMarcadorPadrao
};

export default {
    Marcador,
    Geometria,
    Config
};
